module.exports = __webpack_public_path__ + "img/tg.8d5951fd.png";